<template>
<div class="chapter">
<div class="inner_page">
<div id="prologue">
<div class="story">
<a id="anchor-1-anchor"></a><p class="ch"><span class="generated-style">Prologue</span></p>
<p class="body-text-no-indent"><span class="sc">S</span><span class="sc-epub">HE</span><span class="sc"> </span><span class="sc-epub">LACED</span><span class="sc"> </span><span class="sc-epub">HIS</span><span class="sc"> </span><span class="sc-epub">COFFEE</span><span class="generated-style">
						with opium.</span></p>
<p class="body-text"><span class="generated-style"> He wasn’t supposed to drink
						coffee this late at night. The doctor had told him not to. But she knew how
						much it pleased him to cheat the doctor’s rules just a little every now and
						then.</span></p>
<p class="body-text"><span class="generated-style"> He smiled as she brought it to
						him, smiled again as he took a sip. He liked it sweet.</span></p>
<p class="body-text"><span class="generated-style"> The opium wouldn’t kill him. It
						was part of the ritual, part of the game. She’d given him enough to confuse
						him, enough to slow his wits, to keep him docile and in control as she
						prepared for her checkmate.</span></p>
<p class="body-text"><span class="generated-style"> She kissed the top of his
						balding head and he smiled again, breathing a deep sigh of contentment—the
						king, relaxing after a hard day at the office, secure in his castle
						alongside his beautiful queen.</span></p>
<p class="body-text"><span class="generated-style"> Tonight, this king would
						die.</span></p>
<p class="body-text"><span class="generated-style"><br/><br/></span><span class="sc">T</span><span class="sc-epub">ONY</span><span class="sc"> </span><span class="sc-epub">WAS</span><span class="sc"> </span><span class="sc-epub">BREATHING</span><span class="sc"> </span><span class="sc-epub">HARD</span><span class="sc">.</span><span class="generated-style"> John Miller could hear him clearly over the wire,
						his voice raspy and loud in the radio headset. Tony was breathing hard and
						Miller knew he was scared.</span></p>
<p class="body-text"><span class="generated-style"> “Yeah, that’s right. I’m FBI,”
						Tony said, giving up his cover. Miller knew without a doubt that his partner
						and best friend was in serious, serious trouble. “And if you’re as smart as
						your reputation says you are, Domino, then you’ll order these goons to lay
						down their weapons and surrender to me.”</span></p>
<p class="body-text"><span class="generated-style"> Domino laughed. “I’ve got twenty
						men surrounding you, and you think I’m going to </span><em class="italic">surrender…?</em><span class="generated-style">”</span></p>
<p class="body-text"><span class="generated-style"> “I’ve got more than twenty men
						on backup,” Tony lied, as Miller keyed his radio.</span></p>
<p class="body-text"><span class="generated-style"> “Where the </span><em class="italic">hell</em><span class="generated-style"> is that backup?”
						Miller’s usually unshakable control was nearing a breaking point. He’d been
						ordered to sit tight and wait here outside the warehouse until the choppers
						arrived in a show of force, but he couldn’t wait any longer. He </span><em class="italic">wouldn’t</em><span class="generated-style">
					wait.</span></p>
<p class="body-text"><span class="generated-style"> “Jesus, John, didn’t you get the
						word?” came Fred’s scratchy voice over the radio. “The choppers have been
						rerouted—there’s been an assassination attempt on the governor. It’s code
						red, priority. You’re on your own.”</span></p>
<p class="body-text"><span class="generated-style"> No choppers. No backup. Just
						Tony inside the warehouse, about to be executed by Alfonse Domino, and John
						Miller here, outside.</span></p>
<p class="body-text"><span class="generated-style"> It was the one scenario Miller
						hadn’t considered. It was the one scenario he wasn’t ready for.</span></p>
<p class="body-text"><span class="generated-style"> Miller grabbed the assault rifle
						from the floor of the van and ran toward the warehouse. He needed a miracle,
						but he didn’t waste time praying. He knew full well that he—and Tony—didn’t
						have a prayer.</span></p>
<p class="body-text"><span class="generated-style"><br/><br/></span><span class="sc">“I </span><span class="sc-epub">QUIT</span><span class="sc">.”</span></p>
<p class="body-text"><span class="generated-style"> The board of directors looked at
						her in stunned silence.</span></p>
<p class="body-text"><span class="generated-style"> Marie Carver gazed back at the
						expressions of shock on the familiar faces and knew that those two little
						words she’d uttered had granted her freedom. It was that easy. That simple.
						She quit.</span></p>
<p class="body-text"><span class="generated-style"> “I’ve made arrangements for my
						replacement,” she told them, careful not to let her giddy laughter escape.
						She quit. Tomorrow she would </span><em class="italic">not</em><span class="generated-style"> walk through the front doors and take the elevator
						up to her executive office on the penthouse floor. Tomorrow she would be in
						another place. Another city, another state. Maybe even another country. She
						passed around the hiring reports her secretary had typed up and bound neatly
						with cheery yellow covers. “I’ve done all the preliminary interviews and
						narrowed the candidates down to three—any one of which I myself would have
						utmost faith in as the new president of Carver Software.”</span></p>
<p class="body-text"><span class="generated-style"> All twelve members of the board
						starting talking at once.</span></p>
<p class="body-text"><span class="generated-style"> Marie held up her hand. “Should
						you decide to hire an outside candidate,” she said, “you would, of course,
						require my approval as the major stockholder of this company. But I think
						you’ll be impressed with the choices I’ve given you here.” She rapped the
						yellow-covered report with her knuckles. “I ask that you hold all of your
						questions until after you’ve read this. If any concerns remain unanswered,
						you can reach me at home until six o’clock this evening. After that, I’ll
						remain in touch with my secretary, whom I’ve promoted to Executive
						Assistant.” She smiled. “I appreciate your understanding, and will see you
						all at the next annual shareholders meeting.”</span></p>
<p class="body-text"><span class="generated-style"> She gathered up her briefcase
						and walked quickly out of the room.</span></p>
<p class="body-text"><span class="generated-style"><br/><br/></span><span class="sc">T</span><span class="sc-epub">HE</span><span class="sc"> </span><span class="sc-epub">OPIUM</span><span class="sc"> </span><span class="sc-epub">WAS</span><span class="sc"> </span><span class="generated-style">working.</span></p>
<p class="body-text"><span class="generated-style"> His pupils had retracted almost
						to a pinpoint and he was drooling slightly, blinking sleepily as he watched
						her dance.</span></p>
<p class="body-text"><span class="generated-style"> This was the part she liked.
						This was where she showed him what he would never again have the chance to
						experience, to violate.</span></p>
<p class="body-text"><span class="generated-style"> True, this one had been gentle.
						His soft, old hands had never struck her. He’d been careful not to hurt her.
						He’d given her expensive presents, fancy gifts. But the act itself would
						always be an act of violence, always despicable, always requiring
						punishment.</span></p>
<p class="body-text"><span class="generated-style"> Capital punishment.</span></p>
<p class="body-text"><span class="generated-style"> Her dress fell in a pool of silk
						at her feet, and she deftly stepped out of it. His eyes were glazed, but not
						enough to hide his hunger at the sight of her. He stretched one hand out
						toward her, but he didn’t have the strength to reach her.</span></p>
<p class="body-text"><span class="generated-style"> And still she danced, to the
						rhythm of the blood pounding through her veins, to the anticipation of the
						moment when he would gaze into her eyes and know without a doubt that he was
						a dead man.</span></p>
<p class="body-text"><span class="generated-style"><br/><br/></span><span class="sc">F</span><span class="sc-epub">REEDOM</span><span class="sc">.</span></p>
<p class="body-text"><span class="generated-style"> It hit Marie like the coolness
						of the air that swept through the open door at the end of the hall. It felt
						fresh and clean, like that very spring breeze, bringing hope and life and
						renewal. Through that open door she could see her car, sitting out in the
						parking lot, ready for her escape.</span></p>
<p class="body-text"><span class="generated-style"> “Mariah.”</span></p>
<p class="body-text"><span class="generated-style"> There was only one person on
						that board of directors who could slow her departure. Susan Kane. Aunt
						Susan. Marie turned, but kept moving, backward, down the hall.</span></p>
<p class="body-text"><span class="generated-style"> Susan followed, her long,
						batik-patterned dress moving in the breeze, disapproval in her slate-blue
						eyes. “Mariah,” she said again, calling Marie by her childhood nickname.
						“Obviously you’ve been planning this for some time.”</span></p>
<p class="body-text"><span class="generated-style"> Marie shook her head. “Only two
						weeks.”</span></p>
<p class="body-text"><span class="generated-style"> “I wish you had told
					me.”</span></p>
<p class="body-text"><span class="generated-style"> Marie stopped walking then,
						meeting the older woman’s sternly unwavering gaze. “I couldn’t,” she said.
						“I didn’t tell most of my own staff until this morning.”</span></p>
<p class="body-text"><span class="generated-style"> “Why?”</span></p>
<p class="body-text"><span class="generated-style"> “The company doesn’t need me
						anymore,” Marie said. “It’s been three years since the last layoffs. We’ve
						turned it around, Sue. Profits continue to rise—we’re thriving. You know the
						numbers as well as I do.”</span></p>
<p class="body-text"><span class="generated-style"> “So take a vacation. Take a
						leave of absence. Sit back on your laurels and relax for a
					while.”</span></p>
<p class="body-text"><span class="generated-style"> Marie smiled ruefully. “That’s
						part of my problem,” she said. “I can’t relax.”</span></p>
<p class="body-text"><span class="generated-style"> Susan’s face softened, concern
						in her eyes. “Is your stomach still bothering you?”</span></p>
<p class="body-text"><span class="generated-style"> “Among other things.” Like, for
						instance, the fact that Marie was thirty-two years old and since her divorce
						four years ago, she had no life outside of the office. Like, the fact that
						she still worked long overtime hours to increase profits, to expand, to hire
						more people, even though the failing computer software company that her
						father’s sudden fatal heart attack had thrust into her lap had long ago
						become a Fortune 500 business. Like, the fact that each morning she found
						herself walking into the new, fancy office building into which the company
						had recently moved, and she wondered, what exactly was the point? What
						purpose did she serve by being here, by stressing herself out enough to
						develop stomach ulcers over the mundane, day-to-day operation of this
						business?</span></p>
<p class="body-text"><span class="generated-style"> One day she was going to wake
						up, and she was going to be sixty years old and still walking into that
						building, still going home much too late to that sad excuse for a condo,
						still living out of boxes that she </span><em class="italic">still</em><span class="generated-style"> hadn’t managed to
					unpack.</span></p>
<p class="body-text"><span class="generated-style"> And she’d look at her life, and
						all those meaningless, wasted years would stretch back into her meaningless,
						wasted past.</span></p>
<p class="body-text"><span class="generated-style"> Because the truth was, even
						though she’d dutifully gotten her degree in business as her father had
						wanted, Marie had never wanted to run this company.</span></p>
<p class="body-text"><span class="generated-style"> Shoot, it had taken years before
						she’d admitted that to herself. As far as knowing what she really wanted to
						do, Marie honestly didn’t have a clue. But there was something that she did
						know.</span></p>
<p class="body-text"><span class="generated-style"> She wanted to do more than keep
						a multimillion-dollar corporation up and running. She wanted to have a sense
						of real purpose. She wanted to be able to look back on her life and feel
						proud—feel as if she’d truly made a difference.</span></p>
<p class="body-text"><span class="generated-style"> She was considering running for
						office. She was also thinking about joining the peace corps. She had found a
						list a mile long of volunteer organizations that desperately needed man
						power—everything from accountants for the Salvation Army to hands-on,
						hammer-wielding home builders for Foundations for Families.</span></p>
<p class="body-text"><span class="generated-style"> But before she could do
						anything, she had to handle her stress.</span></p>
<p class="body-text"><span class="generated-style"> Step one was cutting herself off
						from this company—breaking her addiction to this job and the company’s
						addiction to her. She was going to do it cold turkey.</span></p>
<p class="body-text"><span class="generated-style"> The company would survive. Marie
						knew they’d survive. Any one of her three job candidates would bring a
						freshness and vitality to the job that she’d lacked for nearly two years
						now. Whether or not Marie would survive was a different story…</span></p>
<p class="body-text"><span class="generated-style"> “Where are you going?” Susan
						asked.</span></p>
<p class="body-text"><span class="generated-style"> “I don’t know,” Marie admitted.
						“I’m just going to take my camera and go. I read in a book about
						stress-reduction that I should take a few months and leave everything
						behind—including my name. This book recommended that I temporarily take on a
						new identity. Supposedly that’ll help me distance myself from everything
						that’s been causing my ulcers.” She smiled. “I’m going to leave Marie Carver
						locked in my condo—along with all my doubts about my sanity and my worries
						that Carver Software will go into a nosedive the moment I leave
						town.”</span></p>
<p class="body-text"><span class="generated-style"> Susan pulled her in for a quick
						hug—an unusual display of affection. “The job will be yours again when you
						come back,” the older woman whispered. “I’ll make sure of that.”</span></p>
<p class="body-text"><span class="generated-style"> Marie pulled away, unable to
						answer. If she had her way, she’d never be back. If she had her way, Marie
						Carver and her damned ulcers would be gone forever.</span></p>
<p class="body-text"><span class="generated-style"><br/><br/></span><span class="sc">S</span><span class="sc-epub">HE</span><span class="sc"> </span><span class="sc-epub">USED</span><span class="sc"> </span><span class="sc-epub">THE</span><span class="sc"> </span><span class="sc-epub">KNIFE</span><span class="sc"> </span><span class="sc-epub">TO</span><span class="sc"> </span><span class="sc-epub">CUT</span><span class="generated-style"> off a lock of his hair.</span></p>
<p class="body-text"><span class="generated-style"> He didn’t have too much, just a
						light fringe of gray at the back of his head, but that didn’t matter. It was
						the only thing of his that she would keep.</span></p>
<p class="body-text"><span class="generated-style"> Besides the money.</span></p>
<p class="body-text"><span class="generated-style"> He was handcuffed now. He’d let
						her do that willingly, thinking she was playing some new sex game, never
						suspecting he had only moments left to live.</span></p>
<p class="body-text"><span class="generated-style"> But when she unsheathed the
						stiletto, there was a hint of consternation in his drug-glazed
					eyes.</span></p>
<p class="body-text"><span class="generated-style"> “What are you doing?” he
						asked.</span></p>
<p class="body-text"><span class="generated-style"> She shushed him with a kiss. He
						couldn’t speak. He wasn’t allowed to speak.</span></p>
<p class="body-text"><span class="generated-style"> But he didn’t know the rules.
						“Clarise?” he said, fear pushing past the opium, creeping into his voice,
						making it waver as she set the tip of the stiletto against his
					chest.</span></p>
<p class="body-text"><span class="generated-style"> She felt a flash of
						regret.</span></p>
<p class="body-text"><span class="generated-style"> Clarise. She liked that name a
						lot. It was a shame that she would only be Clarise for a few moments longer.
						She couldn’t use that name again. And she wouldn’t. She was too smart to
						make that mistake.</span></p>
<p class="body-text"><span class="generated-style"> “This has gone far enough,” he
						said, trying to hide his fear behind an air of authority. “Release me now,
						Clarise.”</span></p>
<p class="body-text"><span class="generated-style"> She smiled and leaned on the
						whisper-thin blade, sliding it deep into his heart, setting him forever
						free.</span></p>
<p class="body-text"><span class="generated-style"><br/><br/></span><span class="sc">“K</span><span class="sc-epub">ILL</span><span class="sc"> </span><span class="sc-epub">HIM</span><span class="sc">.”</span></p>
<p class="body-text"><span class="generated-style"> Domino’s order came before John
						Miller had reached the warehouse doors, and the gunshots—four of them in
						rapid sequence were amplified deafeningly through his headset.</span></p>
<p class="body-text"><span class="generated-style"> Tony.</span></p>
<p class="body-text"><span class="generated-style"> Tony was dead.</span></p>
<p class="body-text"><span class="generated-style"> Miller knew it. He had no chance
						of saving his friend.</span></p>
<p class="body-text"><span class="generated-style"> He had this tape, though, this
						tape of Domino giving the order to off a federal agent. He had enough
						evidence to put Domino on death row. Blasting his way through that warehouse
						door at twenty to one odds would only get himself killed, too.</span></p>
<p class="body-text"><span class="generated-style"> He knew that as well as he knew
						his own heartbeat.</span></p>
<p class="body-text"><span class="generated-style"> But the heart that was pounding
						in his chest wasn’t beating with a recognizable rhythm. And the red cloud of
						rage that covered his eyes didn’t obscure his vision, but rather made it
						sharper, clearer.</span></p>
<p class="body-text"><span class="generated-style"> Tony was dead, and the son of a
						bitch who ordered it done was </span><em class="italic">not</em><span class="generated-style"> going to make his escape in a powerboat, losing
						himself in South America, outside of the FBI’s jurisdiction. No, Alfonse
						Domino was going to burn in hell.</span></p>
<p class="body-text"><span class="generated-style"> Miller hit the warehouse door at
						full run, bringing his gun up and into position at his hip, shouting in rage
						at the sight of Tony’s crumpled body lying on the cold, blood-soaked
						concrete, shooting the surprise off the faces of Alfonse Domino and his
						men.</span></p>
<p class="body-text"><span class="generated-style"><br/><br/></span><span class="sc">S</span><span class="sc-epub">HE</span><span class="sc"> </span><span class="sc-epub">HAD</span><span class="sc"> </span><span class="sc-epub">HER</span><span class="sc"> </span><span class="sc-epub">AIRLINE</span><span class="sc"> </span><span class="sc-epub">TICKET</span><span class="generated-style"> all ready, under an assumed
						name, of course. A temporary name.</span></p>
<p class="body-text"><span class="generated-style"> Jane Riley. Plain Jane. Plane
						Jane. The thought amused her and she smiled. But only briefly. She knew she
						had a noticeable smile, and right now she had no desire to be
						noticed.</span></p>
<p class="body-text"><span class="generated-style"> Her hair was under a kerchief
						for the occasion, and she wore a dowdy camel-colored jacket she’d picked up
						at a secondhand store downtown.</span></p>
<p class="body-text"><span class="generated-style"> She took nothing of Clarise’s
						with her. Nothing but the money and her collection. Nine locks of
						hair.</span></p>
<p class="body-text"><span class="generated-style"> She traveled light, boarding the
						plane to Atlanta with only a tote bag that held several novels she’d picked
						up at the airport shop and two hundred thousand dollars in cash. The rest of
						the money was already in her Swiss bank account.</span></p>
<p class="body-text"><span class="generated-style"> In Atlanta, she’d catch a train
						to who knows where. Maybe New York. Maybe Philadelphia.</span></p>
<p class="body-text"><span class="generated-style"> She’d catch a show or two, take
						her time deciding exactly who she wanted to be. Then she’d get her hair cut
						and colored, shop for a new wardrobe to match her new personality, pick a
						new town in a new state, and start the game all over again.</span></p>
<p class="body-text"><span class="generated-style"> And then she’d have ten locks of
						hair.</span></p>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Prologue.vue?55b4a476